import { baseApiAuthenticated } from '@/api/v2/index';
import { urlBuilder } from '@/api/utils';
import { CreateUser, User } from '@/models/user';

type GetUsersResponse = {
    liftOperatorUsers: User[];
};

const userUrls = {
    user: urlBuilder('auth', `liftoperator-users`),
};

export const userApi = baseApiAuthenticated
    .enhanceEndpoints({ addTagTypes: ['USERS'] })
    .injectEndpoints({
        endpoints: (builder) => ({
            getUsers: builder.query<User[], { liftOperatorId: string }>({
                query: ({ liftOperatorId }) =>
                    `${userUrls.user}/${liftOperatorId}`,
                transformResponse: ({
                    liftOperatorUsers,
                }: GetUsersResponse) => {
                    return liftOperatorUsers;
                },
                providesTags: ['USERS'],
            }),

            postUser: builder.mutation<User, CreateUser>({
                query: (user) => ({
                    method: 'POST',
                    url: `${userUrls.user}/${user.liftOperatorId}`,
                    body: user,
                }),
                invalidatesTags: ['USERS'],
            }),

            putUser: builder.mutation<User, User>({
                query: (user) => ({
                    method: 'PUT',
                    url: `${userUrls.user}/${user.liftOperatorId}/${user.id}`,
                    body: user,
                }),
                invalidatesTags: ['USERS'],
            }),

            deleteUser: builder.mutation<
                void,
                { liftOperatorId: string; userId: string }
            >({
                query: ({ liftOperatorId, userId }) => ({
                    method: 'DELETE',
                    url: `${userUrls.user}/${liftOperatorId}/${userId}`,
                }),
                invalidatesTags: ['USERS'],
            }),
        }),
    });

export const {
    useGetUsersQuery,
    useDeleteUserMutation,
    usePostUserMutation,
    usePutUserMutation,
} = userApi;
